import { getEvoAccessToken } from '../../hooks/useEvoContext';
import { isIframeMode } from '../../lib/environmentUtils';
import { getDevRoleOverride } from '../../lib/devRoleOverride';

export function getApiHeaders(): Record<string, string> {
  return {
    'x-api-key': import.meta.env.VITE_X_API_KEY,
  };
}

export async function getAuthenticatedHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};

  const evoToken = await getEvoAccessToken();
  if (evoToken) {
    headers['Authorization'] = `Bearer ${evoToken}`;
    console.log('ProjectApproval_ [AuthHeaders] Bearer token attached');
  } else {
    console.warn('ProjectApproval_ [AuthHeaders] No EVO access token obtained (isIframeMode: %s)', isIframeMode());
  }

  const apiKey = import.meta.env.VITE_X_API_KEY;
  if (apiKey) {
    headers['x-api-key'] = apiKey;
  }

  const roleOverride = getDevRoleOverride();
  if (roleOverride) {
    headers['X-Dev-Role-Override'] = roleOverride;
  }

  return headers;
}
